export const featuredProducts = [
  {
    id: 1,
    name: "Premium Kolajen Takviyesi",
    category: "Kolajen",
    price: 299.90,
    image: "https://readdy.ai/api/search-image?query=premium%20marine%20collagen%20supplement%20powder%20in%20elegant%20white%20and%20gold%20container%20on%20clean%20white%20background%20with%20subtle%20botanical%20elements%2C%20luxury%20health%20product%20photography%2C%20sophisticated%20minimalist%20design%2C%20soft%20natural%20studio%20lighting%2C%20high%20quality%20professional%20image&width=400&height=400&seq=col1new&orientation=squarish",
    rating: 4.8,
    reviews: 156,
    badge: "Çok Satan"
  },
  {
    id: 2,
    name: "Çocuklar İçin Kolajen",
    category: "Kolajen",
    price: 249.90,
    image: "https://readdy.ai/api/search-image?query=children%20collagen%20supplement%20bottle%20with%20playful%20colorful%20design%20featuring%20cartoon%20characters%20for%20kids%20aged%202%20to%2016%20years%2C%20kid-friendly%20health%20product%20on%20white%20background%2C%20professional%20photography%2C%20bright%20cheerful%20packaging%2C%20clean%20studio%20lighting&width=400&height=400&seq=col2new&orientation=squarish",
    rating: 4.9,
    reviews: 203,
    badge: "Yeni"
  },
  {
    id: 3,
    name: "Organik Omega-3",
    category: "Takviye Gıda",
    price: 189.90,
    image: "https://readdy.ai/api/search-image?query=organic%20omega-3%20fish%20oil%20capsules%20in%20premium%20amber%20glass%20bottle%20with%20natural%20fish%20and%20ocean%20elements%20on%20white%20background%2C%20natural%20health%20supplement%2C%20professional%20product%20photography%2C%20premium%20quality%2C%20soft%20shadows%20and%20clean%20lighting&width=400&height=400&seq=omega1new&orientation=squarish",
    rating: 4.7,
    reviews: 128,
    badge: null
  },
  {
    id: 4,
    name: "Probiyotik Kompleks",
    category: "Takviye Gıda",
    price: 219.90,
    image: "https://readdy.ai/api/search-image?query=probiotic%20supplement%20bottle%20with%20modern%20minimalist%20design%20and%20yogurt%20culture%20imagery%20on%20white%20background%2C%20digestive%20health%20product%2C%20professional%20photography%2C%20clean%20fresh%20look%20with%20natural%20elements%2C%20natural%20lighting&width=400&height=400&seq=prob1new&orientation=squarish",
    rating: 4.6,
    reviews: 94,
    badge: null
  },
  {
    id: 5,
    name: "Aile Vitamin Paketi",
    category: "Vitamin",
    price: 349.90,
    image: "https://readdy.ai/api/search-image?query=family%20vitamin%20supplement%20set%20with%20multiple%20bottles%20arranged%20elegantly%20on%20white%20background%20showing%20products%20for%20all%20ages%20from%20babies%20to%20adults%2C%20complete%20health%20package%2C%20professional%20product%20photography%2C%20organized%20premium%20arrangement%2C%20bright%20inviting%20lighting&width=400&height=400&seq=vit1new&orientation=squarish",
    rating: 4.9,
    reviews: 187,
    badge: "Popüler"
  },
  {
    id: 6,
    name: "Organik C Vitamini",
    category: "Vitamin",
    price: 159.90,
    image: "https://readdy.ai/api/search-image?query=organic%20vitamin%20C%20supplement%20in%20elegant%20bottle%20with%20fresh%20orange%20and%20citrus%20fruit%20elements%20on%20white%20background%2C%20natural%20health%20product%2C%20professional%20photography%2C%20fresh%20clean%20design%20with%20botanical%20accents%2C%20soft%20studio%20lighting&width=400&height=400&seq=vitc1new&orientation=squarish",
    rating: 4.8,
    reviews: 142,
    badge: null
  },
  {
    id: 7,
    name: "Deniz Kolajen Plus",
    category: "Kolajen",
    price: 329.90,
    image: "https://readdy.ai/api/search-image?query=marine%20collagen%20supplement%20in%20premium%20blue%20and%20white%20packaging%20with%20ocean%20wave%20design%20on%20white%20background%2C%20luxury%20health%20product%2C%20professional%20photography%2C%20elegant%20sophisticated%20design%2C%20soft%20natural%20lighting&width=400&height=400&seq=col3new&orientation=squarish",
    rating: 4.9,
    reviews: 221,
    badge: "Premium"
  },
  {
    id: 8,
    name: "Organik Magnezyum",
    category: "Mineral",
    price: 179.90,
    image: "https://readdy.ai/api/search-image?query=organic%20magnesium%20supplement%20bottle%20with%20natural%20green%20leaf%20accents%20and%20mineral%20crystals%20on%20white%20background%2C%20mineral%20health%20product%2C%20professional%20photography%2C%20clean%20modern%20design%20with%20botanical%20elements%2C%20soft%20lighting&width=400&height=400&seq=mag1new&orientation=squarish",
    rating: 4.7,
    reviews: 115,
    badge: null
  },
  {
    id: 9,
    name: "Bebek D3 Vitamini",
    category: "Bebek",
    price: 129.90,
    image: "https://readdy.ai/api/search-image?query=baby%20vitamin%20D3%20drops%20in%20gentle%20pastel%20colored%20bottle%20with%20cute%20baby-safe%20design%20on%20white%20background%2C%20infant%20health%20supplement%20for%200-2%20years%2C%20professional%20photography%2C%20soft%20caring%20appearance%2C%20natural%20lighting&width=400&height=400&seq=babyd3&orientation=squarish",
    rating: 5.0,
    reviews: 312,
    badge: "En Çok Satan"
  },
  {
    id: 10,
    name: "Çocuk Multivitamin",
    category: "Çocuk",
    price: 169.90,
    image: "https://readdy.ai/api/search-image?query=children%20multivitamin%20gummies%20in%20colorful%20fun%20bottle%20with%20playful%20design%20for%20kids%20aged%203-12%20years%20on%20white%20background%2C%20kid-friendly%20supplement%2C%20professional%20photography%2C%20bright%20cheerful%20colors%2C%20clean%20lighting&width=400&height=400&seq=kidmulti&orientation=squarish",
    rating: 4.9,
    reviews: 267,
    badge: "Çok Satan"
  },
  {
    id: 11,
    name: "Ergen Büyüme Desteği",
    category: "Ergen",
    price: 279.90,
    image: "https://readdy.ai/api/search-image?query=teenage%20growth%20support%20supplement%20in%20modern%20sporty%20bottle%20design%20for%20ages%2013-16%20years%20on%20white%20background%2C%20adolescent%20health%20product%2C%20professional%20photography%2C%20energetic%20youthful%20design%2C%20natural%20lighting&width=400&height=400&seq=teengrow&orientation=squarish",
    rating: 4.8,
    reviews: 189,
    badge: "Yeni"
  },
  {
    id: 12,
    name: "Aile Probiyotik Seti",
    category: "Aile",
    price: 399.90,
    image: "https://readdy.ai/api/search-image?query=family%20probiotic%20supplement%20set%20with%20multiple%20bottles%20for%20all%20ages%20from%20babies%20to%20adults%20on%20white%20background%2C%20complete%20digestive%20health%20package%2C%20professional%20photography%2C%20organized%20premium%20display%2C%20bright%20lighting&width=400&height=400&seq=famprob&orientation=squarish",
    rating: 4.9,
    reviews: 234,
    badge: "Popüler"
  }
];

export const collagenProducts = [
  {
    id: 1,
    name: "Premium Deniz Kolajen",
    description: "Tip 1 deniz kolajen ile cilt elastikiyeti ve eklem sağlığı desteği",
    price: "₺299,90",
    oldPrice: "₺399,90",
    image: "https://readdy.ai/api/search-image?query=premium%20marine%20collagen%20supplement%20powder%20in%20elegant%20white%20and%20turquoise%20container%20with%20ocean%20elements%2C%20luxury%20health%20product%20photography%2C%20sophisticated%20minimalist%20design%2C%20soft%20natural%20studio%20lighting%2C%20high%20quality%20professional%20image&width=400&height=400&seq=colprem1&orientation=squarish",
    rating: 4.9,
    badge: "En Çok Satan"
  },
  {
    id: 2,
    name: "Kolajen + C Vitamini",
    description: "Deniz kolajen ve C vitamini ile güçlendirilmiş cilt güzelliği formülü",
    price: "₺279,90",
    oldPrice: null,
    image: "https://readdy.ai/api/search-image?query=marine%20collagen%20with%20vitamin%20C%20supplement%20in%20elegant%20white%20bottle%20with%20citrus%20and%20ocean%20elements%20on%20white%20background%2C%20beauty%20health%20product%2C%20professional%20photography%2C%20fresh%20clean%20design%2C%20soft%20lighting&width=400&height=400&seq=colvitnew&orientation=squarish",
    rating: 4.8,
    badge: "Yeni"
  },
  {
    id: 3,
    name: "Eklem Sağlığı Kolajen",
    description: "Tip 2 kolajen ile eklem ağrılarını azaltır ve hareket kabiliyetini artırır",
    price: "₺319,90",
    oldPrice: "₺429,90",
    image: "https://readdy.ai/api/search-image?query=joint%20health%20collagen%20supplement%20in%20premium%20turquoise%20and%20white%20packaging%20with%20bone%20and%20joint%20imagery%20on%20white%20background%2C%20medical%20health%20product%2C%20professional%20photography%2C%20clean%20modern%20design%2C%20soft%20lighting&width=400&height=400&seq=coljoint1&orientation=squarish",
    rating: 4.7,
    badge: "Premium"
  },
  {
    id: 4,
    name: "Cilt Güzelliği Kolajen",
    description: "Kırışıklık karşıtı özel formül, cilt parlaklığı ve nem desteği",
    price: "₺289,90",
    oldPrice: null,
    image: "https://readdy.ai/api/search-image?query=beauty%20collagen%20supplement%20in%20elegant%20pink%20and%20white%20bottle%20with%20rose%20petals%20and%20botanical%20elements%20on%20white%20background%2C%20skincare%20health%20product%2C%20professional%20photography%2C%20feminine%20sophisticated%20design%2C%20soft%20lighting&width=400&height=400&seq=colbeauty1&orientation=squarish",
    rating: 4.9,
    badge: "Popüler"
  },
  {
    id: 5,
    name: "Kolajen + Hyaluronik Asit",
    description: "Deniz kolajen ve hyaluronik asit ile derin nem ve dolgunluk",
    price: "₺339,90",
    oldPrice: "₺449,90",
    image: "https://readdy.ai/api/search-image?query=collagen%20with%20hyaluronic%20acid%20supplement%20in%20luxury%20white%20and%20turquoise%20bottle%20with%20water%20droplets%20on%20white%20background%2C%20premium%20beauty%20product%2C%20professional%20photography%2C%20elegant%20modern%20design%2C%20soft%20lighting&width=400&height=400&seq=colhyal1&orientation=squarish",
    rating: 4.8,
    badge: "Yeni"
  },
  {
    id: 6,
    name: "Kemik Yoğunluğu Kolajen",
    description: "Kalsiyum ve D vitamini ile güçlendirilmiş kemik sağlığı desteği",
    price: "₺309,90",
    oldPrice: null,
    image: "https://readdy.ai/api/search-image?query=bone%20health%20collagen%20supplement%20with%20calcium%20in%20white%20and%20turquoise%20bottle%20with%20bone%20structure%20imagery%20on%20white%20background%2C%20medical%20health%20product%2C%20professional%20photography%2C%20clean%20design%2C%20soft%20lighting&width=400&height=400&seq=colbone1&orientation=squarish",
    rating: 4.7,
    badge: null
  },
  {
    id: 7,
    name: "Saç ve Tırnak Kolajen",
    description: "Biotin ve keratin ile güçlendirilmiş saç ve tırnak sağlığı formülü",
    price: "₺269,90",
    oldPrice: "₺349,90",
    image: "https://readdy.ai/api/search-image?query=hair%20and%20nail%20collagen%20supplement%20in%20elegant%20bottle%20with%20hair%20strand%20and%20botanical%20elements%20on%20white%20background%2C%20beauty%20health%20product%2C%20professional%20photography%2C%20sophisticated%20design%2C%20soft%20lighting&width=400&height=400&seq=colhair1&orientation=squarish",
    rating: 4.8,
    badge: "Çok Satan"
  },
  {
    id: 8,
    name: "Antioksidan Kolajen",
    description: "E vitamini ve antioksidanlarla zenginleştirilmiş yaşlanma karşıtı formül",
    price: "₺329,90",
    oldPrice: null,
    image: "https://readdy.ai/api/search-image?query=antioxidant%20collagen%20supplement%20in%20premium%20white%20and%20gold%20bottle%20with%20berry%20and%20botanical%20elements%20on%20white%20background%2C%20anti-aging%20health%20product%2C%20professional%20photography%2C%20luxury%20design%2C%20soft%20lighting&width=400&height=400&seq=colanti1&orientation=squarish",
    rating: 4.9,
    badge: "Premium"
  }
];

export const categories = [
  {
    id: 1,
    name: "Kolajen Ürünleri",
    icon: "ri-heart-pulse-line",
    count: 24,
    image: "https://readdy.ai/api/search-image?query=collagen%20powder%20and%20supplements%20collection%20on%20clean%20white%20background%2C%20health%20and%20beauty%20products%2C%20professional%20photography%2C%20elegant%20arrangement%2C%20soft%20natural%20lighting&width=300&height=300&seq=cat1&orientation=squarish"
  },
  {
    id: 2,
    name: "Organik Vitaminler",
    icon: "ri-capsule-line",
    count: 32,
    image: "https://readdy.ai/api/search-image?query=organic%20vitamin%20bottles%20and%20supplements%20on%20white%20background%2C%20natural%20health%20products%2C%20professional%20photography%2C%20colorful%20and%20vibrant%2C%20clean%20studio%20lighting&width=300&height=300&seq=cat2&orientation=squarish"
  },
  {
    id: 3,
    name: "Probiyotikler",
    icon: "ri-flask-line",
    count: 18,
    image: "https://readdy.ai/api/search-image?query=probiotic%20supplements%20and%20digestive%20health%20products%20on%20white%20background%2C%20wellness%20items%2C%20professional%20photography%2C%20fresh%20and%20clean%20look%2C%20soft%20lighting&width=300&height=300&seq=cat3&orientation=squarish"
  },
  {
    id: 4,
    name: "Omega-3 & Yağlar",
    icon: "ri-drop-line",
    count: 15,
    image: "https://readdy.ai/api/search-image?query=omega-3%20fish%20oil%20capsules%20and%20bottles%20on%20white%20background%2C%20essential%20fatty%20acids%20supplements%2C%20professional%20photography%2C%20premium%20quality%20look%2C%20natural%20lighting&width=300&height=300&seq=cat4&orientation=squarish"
  },
  {
    id: 5,
    name: "Çocuk Ürünleri",
    icon: "ri-bear-smile-line",
    count: 28,
    image: "https://readdy.ai/api/search-image?query=children%20health%20supplements%20with%20playful%20colorful%20packaging%20on%20white%20background%2C%20kid-friendly%20products%2C%20professional%20photography%2C%20bright%20and%20cheerful%2C%20soft%20lighting&width=300&height=300&seq=cat5&orientation=squarish"
  },
  {
    id: 6,
    name: "Mineral Takviyeleri",
    icon: "ri-test-tube-line",
    count: 21,
    image: "https://readdy.ai/api/search-image?query=mineral%20supplements%20and%20tablets%20on%20white%20background%2C%20health%20products%2C%20professional%20photography%2C%20organized%20display%2C%20clean%20studio%20lighting&width=300&height=300&seq=cat6&orientation=squarish"
  }
];

export const sliderItems = [
  {
    id: 1,
    title: "Yeni Sezon Kolajen Ürünleri",
    subtitle: "Cilt ve eklem sağlığınız için",
    description: "Premium kalitede deniz kolajenimizle gençliğinizi koruyun",
    image: "https://readdy.ai/api/search-image?query=elegant%20collagen%20supplement%20product%20display%20with%20natural%20botanical%20elements%20and%20soft%20pink%20tones%20on%20white%20background%2C%20luxury%20health%20and%20beauty%20concept%2C%20professional%20photography%2C%20sophisticated%20composition%2C%20gentle%20natural%20lighting&width=600&height=400&seq=slide1&orientation=landscape",
    discount: "%25 İndirim",
    cta: "Keşfet"
  },
  {
    id: 2,
    title: "Organik Takviye Gıdalar",
    subtitle: "Doğal ve güvenilir",
    description: "Aileniz için %100 organik sertifikalı ürünler",
    image: "https://readdy.ai/api/search-image?query=organic%20health%20supplements%20with%20fresh%20green%20leaves%20and%20natural%20ingredients%20on%20white%20background%2C%20wellness%20and%20nutrition%20concept%2C%20professional%20photography%2C%20fresh%20and%20vibrant%2C%20soft%20natural%20lighting&width=600&height=400&seq=slide2&orientation=landscape",
    discount: "Yeni",
    cta: "İncele"
  },
  {
    id: 3,
    title: "Çocuklar İçin Özel Formül",
    subtitle: "Güvenli ve lezzetli",
    description: "Çocuklarınızın sağlıklı büyümesi için özel formüller",
    image: "https://readdy.ai/api/search-image?query=children%20health%20supplements%20with%20playful%20colorful%20elements%20and%20happy%20family%20concept%20on%20white%20background%2C%20kid-friendly%20products%2C%20professional%20photography%2C%20bright%20and%20cheerful%2C%20soft%20lighting&width=600&height=400&seq=slide3&orientation=landscape",
    discount: "Popüler",
    cta: "Satın Al"
  }
];
